import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=af773010&scoped=true&"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=js&"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af773010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2044461438/src/tacotrade-platform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af773010')) {
      api.createRecord('af773010', component.options)
    } else {
      api.reload('af773010', component.options)
    }
    module.hot.accept("./GlobalSnackbar.vue?vue&type=template&id=af773010&scoped=true&", function () {
      api.rerender('af773010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalSnackbar.vue"
export default component.exports